import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_KIDS } from 'src/app/core/constants';

@Component({
    selector: 'app-kids-attached',
    templateUrl: './kids-attached.component.html',
    styleUrls: ['./kids-attached.component.scss'],
})
export class KidsAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto kids
     */
    public departmentType: string = DEPARTMENT_TYPE_KIDS;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
